// extracted by mini-css-extract-plugin
module.exports = {"grid":"widgets_grid__4XWwI","cell":"widgets_cell__72oor","edit":"widgets_edit__xI78q","editButton":"widgets_editButton__ogQBx"};